module.exports = __webpack_public_path__ + "static/media/roma-4.61aec9f2.jpeg";